<script>
  import { onMount } from 'svelte'
  import { db } from '../util.js'

  let content = 'Loading...'
  let title = ''

  onMount(() => {
    db.get('/facilities.json').then(data => {
      content = data.body
      document.title = title = data.title
    })
  })
</script>

<iframe src="https://player.vimeo.com/video/208335372?autoplay=1&muted=1;loop=1" title="Sunvair Facilities" style="width: 100vw; height: 60vw;" frameborder="0" allowfullscreen="true"></iframe>
<div class="text">
  <h1>{title}</h1>
  {@html content}
</div>

<style>
  h1{
    padding: 0;
  }
  .text{
    margin: 40px 6%;
  }
</style>
